import { render, staticRenderFns } from "./setRemark.vue?vue&type=template&id=22f34173&scoped=true&"
import script from "./setRemark.vue?vue&type=script&lang=js&"
export * from "./setRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f34173",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f34173')) {
      api.createRecord('22f34173', component.options)
    } else {
      api.reload('22f34173', component.options)
    }
    module.hot.accept("./setRemark.vue?vue&type=template&id=22f34173&scoped=true&", function () {
      api.rerender('22f34173', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/setRemark.vue"
export default component.exports